import {useNavigate} from "react-router";
import {useAppSelector} from "../../hooks/reduxHooks.ts";
import {useGarageScope} from "../../hooks/useGarageScope.ts";
import React, {useEffect, useState} from "react";
import {useRoutesByTag} from "../../service/routeProvider.tsx";
import FrameLoad from "../layout/FrameLoad.tsx";

interface RequiresDpaProps {
    children: React.ReactNode;
    disable?: boolean;
}

export const RequiresDpa = (props: RequiresDpaProps) => {
    const navigate = useNavigate();
    const agreementFaulty = useAppSelector(state => state.auth.agreementFaulty);
    const {isAdmin} = useGarageScope();
    const dpaRoutes = useRoutesByTag("DPA");
    const [isLoading, setIsLoading] = useState(true);

    const disabled = !!props.disable;

    useEffect(() => {
        if (!isAdmin && agreementFaulty && !disabled) {
            if (dpaRoutes.length === 1) {
                void navigate(dpaRoutes[0].path);
            } else {
                throw new Error("no or more than one route with tag DPA configured: " + dpaRoutes.length);
            }
        }
        setIsLoading(false);
    }, [agreementFaulty, navigate, isAdmin, disabled, dpaRoutes]);

    if (isLoading) return <FrameLoad/>;

    return <>{props.children}</>;
};
